export default {
  survey: state => state.survey
}
